export default __webpack_public_path__ + "static/media/lock-unit.6daaf402.svg";